export const warningUploading = 'Changes you made may not be saved.';

// Key code
export const ENTER = 13;
export const COMMA = 188;
